// extracted by mini-css-extract-plugin
export default {"commentBox":"AddComment_commentBox__SZrnQ","submitButton":"AddComment_submitButton__-7935"};